import {createContext, ReactNode, useEffect, useState} from "react";
import {IconButton, Snackbar} from "@mui/joy";
import {Close} from "@mui/icons-material";
import 'firebase/compat/auth';


export const FeedbackContext = createContext<any>(null);

interface FeedbackProviderProps {
    children?: ReactNode
}

export function FeedbackProvider(props: FeedbackProviderProps) {
    const [bigloading, setBigLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>("");
    const [errorVisible, setErrorVisible] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        if(error !== undefined && error !== "" && error !== null) {
            setErrorVisible(true)
        }
    }, [error])


    return (
        <FeedbackContext.Provider value={{loading, bigloading, error, message, setLoading, setBigLoading, setError, setMessage}}>
            {props.children}
            <Snackbar
                autoHideDuration={5000}
                open={errorVisible}
                variant="outlined"
                color="danger"
                size="md"
                onClose={() => {
                    setErrorVisible(false)
                }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                endDecorator={
                    <IconButton
                        onClick={() => {
                            setErrorVisible(false)
                        }}
                        size="sm"
                    >
                        <Close />
                    </IconButton>
                }
            >
                {error.message ?? error.toString()}
            </Snackbar>
            <Snackbar
                autoHideDuration={5000}
                open={message !== ""}
                variant="outlined"
                color="primary"
                size="md"
                onClose={() => {
                    setMessage("");
                }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                endDecorator={
                    <IconButton
                        onClick={() => setMessage("")}
                        size="sm"
                    >
                        <Close />
                    </IconButton>
                }
            >
                {message}
            </Snackbar>
        </FeedbackContext.Provider>
    )
}